/** 优惠券类型 */
export var CouponType;
(function (CouponType) {
    /** 默认(带prize logo券) */
    CouponType["default"] = "default";
    /** 现金券 */
    CouponType["cash"] = "cash";
    /** 折扣券 */
    CouponType["discount"] = "discount";
    /** 连锁券 */
    // chain = 'chain',
})(CouponType || (CouponType = {}));
/** 券状态 */
export var CouponState;
(function (CouponState) {
    /** 未领取 */
    CouponState["notReceived"] = "0";
    /** 已领取 */
    CouponState["received"] = "1";
    /** 已使用 */
    CouponState["used"] = "2";
    /** 已过期 */
    CouponState["expired"] = "3";
})(CouponState || (CouponState = {}));
/** 券兑换状态 */
export var ExchangeState;
(function (ExchangeState) {
    /** 未开始 */
    ExchangeState[ExchangeState["notStarted"] = 1] = "notStarted";
    /** 可兑换，展示库存 */
    ExchangeState[ExchangeState["avaliable"] = 2] = "avaliable";
    /** 奖品维度-日限额 今日已领完 */
    ExchangeState[ExchangeState["dayLimit"] = 3] = "dayLimit";
    /** 奖品维度-总限额 券已售罄 */
    ExchangeState[ExchangeState["totalLimit"] = 4] = "totalLimit";
    /** 用户维度-总限额 */
    ExchangeState[ExchangeState["totalUserLmit"] = 5] = "totalUserLmit";
    /** 用户维度-月限额 */
    ExchangeState[ExchangeState["monthUserLimit"] = 6] = "monthUserLimit";
    /** 印花不足 */
    ExchangeState[ExchangeState["qualNoEnough"] = 7] = "qualNoEnough";
})(ExchangeState || (ExchangeState = {}));
/** 券使用状态 */
export var TransState;
(function (TransState) {
    /** 1-初始，未使用 */
    TransState[TransState["NOT_USED"] = 1] = "NOT_USED";
    /** 2-已使用 */
    TransState[TransState["USED"] = 2] = "USED";
    /** 3-过期作废 */
    TransState[TransState["NOT_USED_EXPIRED"] = 3] = "NOT_USED_EXPIRED";
    /** 4-已退款（部分退款）*/
    TransState[TransState["REFUND"] = 4] = "REFUND";
})(TransState || (TransState = {}));
/** 券过期状态 */
export var ExpireState;
(function (ExpireState) {
    /** 未过期 */
    ExpireState[ExpireState["NOT_EXPIRED"] = 0] = "NOT_EXPIRED";
    /** 已过期 */
    ExpireState[ExpireState["EXPIRED"] = 1] = "EXPIRED";
})(ExpireState || (ExpireState = {}));
